export default __webpack_public_path__ + "static/media/detail_big_12_6.1c6f776b.jpg";